<template>
  <div>
    <div class="row ml-5 mt-5">
      <div class="col-12">
        <h3>
          ACEITE OS TERMOS ABAIXO PARA CONTINUAR
        </h3>
      </div>
    </div>
    <div class="row ml-5 mt-5">
      <ul class="nav nav-tabs">
        <li
          v-for="(disclaimer, index) in disclaimers"
          :key="index"
          class="nav-item"
        >
          <a 
            :class="`pointer nav-link ${ tab === disclaimer.tab ? 'active' : ''}`" 
            aria-current="page"
            @click="setTab(disclaimer.tab)"
          >
            {{ disclaimer.tab }}
          </a>
        </li>
      </ul>
    </div>
    <div class="row disclaimer_container">
      <div class="col-12">
        <div
          v-for="(disclaimer, index) in disclaimers"
          :key="index"
          class="container"
        >
          <div
            v-if="tab === disclaimer.tab"
          >
            <div class="row">
              <div class="col-12 disclaimer-content">
                <span
                  v-html="disclaimer.description"
                ></span>
              </div>
            </div>
            <hr />
            <div
              v-for="(checkbox, index_checkbox) in disclaimer.checkboxes"
              :key="`checkbox_${index_checkbox}_${index}`"
              class="row mb-5"
            >
              <div class="col-12">
                <input
                  type="checkbox"
                  v-model="disclaimers_value[index]"
                  class="mr-1"
                />
                {{ checkbox }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-12 px-5">
            <button
              class="btn bg-purple mb-1 w-100 px-5 text-white py-2"
              @click="setDisclaimersValue"
            >
              CONTINUAR
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disclaimers: Array,
  },

  data() {
    return {
      tab: null,
      disclaimers_value: [],
    }
  },

  mounted() {
    this.tab = this.disclaimers[0].tab;
  },

  methods: {
    setDisclaimersValue() {
      if (
        this.disclaimers_value.length === 0 ||
        this.disclaimers_value.find((value) => value === false)
      ) {
        this.$toast.error("Aceite os termos para continuar");
        eventBus.$emit('setDisclaimersValue', false);
        return;
      }
      eventBus.$emit('setDisclaimersValue', true);
    },
    setTab(tab) {
      this.tab = tab;
      this.disclaimers_value = [];
    },
  },
}
</script>

<style scoped>
.disclaimer-content {
  margin-top: 20px;
  max-height: 50vh;
  overflow: auto;
}
@media (min-width: 1000px) {
  .disclaimer_container {
    padding-left: 100px;
    padding-right: 100px;
  }
}
</style>